import * as metaData from '../metaData.js';
import { MetadataModules } from '../enums/index.js';
export default function getScalingParameters(imageId) {
    const modalityLutModule = metaData.get(MetadataModules.MODALITY_LUT, imageId) || {};
    const generalSeriesModule = metaData.get(MetadataModules.GENERAL_SERIES, imageId) || {};
    const { modality } = generalSeriesModule;
    const scalingParameters = {
        rescaleSlope: modalityLutModule.rescaleSlope || 1,
        rescaleIntercept: modalityLutModule.rescaleIntercept ?? 0,
        modality,
    };
    const scalingModules = metaData.get(MetadataModules.SCALING, imageId) || {};
    return {
        ...scalingParameters,
        ...(modality === 'PT' && {
            suvbw: scalingModules.suvbw,
            suvbsa: scalingModules.suvbsa,
            suvlbm: scalingModules.suvlbm,
        }),
        ...(modality === 'RTDOSE' && {
            doseGridScaling: scalingModules.DoseGridScaling,
            doseSummation: scalingModules.DoseSummation,
            doseType: scalingModules.DoseType,
            doseUnit: scalingModules.DoseUnit,
        }),
    };
}
